import { render } from "./StepForm.vue?vue&type=template&id=2508ec27&scoped=true"
import script from "./StepForm.vue?vue&type=script&lang=js"
export * from "./StepForm.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=2508ec27&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2508ec27"]])

export default __exports__